import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';

interface DeviceState {
  mobile: boolean;
}

const initialState: DeviceState = {
  mobile: false,
};

export const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setDevice: (state, action: PayloadAction<boolean>) => {
      // console.log(`(deviceSlice) Mobile Device Detected: ${action.payload}`);
      state.mobile = action.payload;
    },
  },
});

export const { setDevice } = deviceSlice.actions;
export const getDevice = (state: RootState) => state.device.mobile;
export default deviceSlice.reducer;
